/**
 * Catalogue des RPC Supabase exposées au front (migrations 010 → 013).
 * Source de vérité pour juntasRpc.js et le mapping sprint.
 */
export const RPC_CATALOG = {
  // Sesión 3 — discovery & algorithme
  get_compatible_matches: {
    sprint: 'S3',
    params: ['user_id_param', 'limit_param'],
    description: 'Profils compatibles triés par score (filtrage serveur).',
  },
  // calculate_compatibility: usage interne uniquement. EXECUTE révoqué au
  // rôle authenticated (migration 046 / B1) — exposerait le filtrage trans
  // silent. Le front passe toujours par get_compatible_matches.

  // Sesión 4 — conversations & sécurité
  send_interest: {
    sprint: 'S3',
    params: ['p_target_user', 'p_first_message'],
    description: 'Primer mensaje + conversación pendiente (mín. 40 car.).',
  },
  get_my_conversations: { sprint: 'S4', params: [], description: 'Inbox conversaciones con último mensaje.' },
  create_piso_group: {
    sprint: 'S4',
    params: ['p_name', 'p_member_ids'],
    description: 'Crear grupo de piso (opción A).',
  },
  invite_to_piso_group: { sprint: 'S4', params: ['p_group_id', 'p_user_id'] },
  activate_piso_group: { sprint: 'S4', params: ['p_group_id'] },
  get_my_piso_groups: { sprint: 'S4', params: [] },
  accept_interest: { sprint: 'S4', params: ['p_conversation_id'] },
  reject_interest: { sprint: 'S4', params: ['p_conversation_id'] },
  block_user: { sprint: 'S4', params: ['p_target_user', 'p_reason'] },
  unblock_user: { sprint: 'S4', params: ['p_block_id'] },
  get_my_blocks: { sprint: 'S4', params: [], description: 'Bloqueos activos de la usuaria (con block_id y can_revert).' },

  // Sesión 5 — KYC & associations
  submit_kyc: {
    sprint: 'S2',
    params: [
      'p_via',
      'p_document_type',
      'p_document_storage_path',
      'p_selfie_storage_path',
      'p_carta_org_id',
      'p_carta_storage_path',
    ],
  },
  redeem_invitation_code: { sprint: 'S2', params: ['p_code'] },
  get_my_attribution: { sprint: 'S2', params: [] },
  set_trans_status: { sprint: 'S2', params: ['p_is_trans', 'p_consent_text_version'] },
  set_trans_preference: {
    sprint: 'S2',
    params: ['p_preference', 'p_consent_text_version'],
  },
  get_my_trans_visibility_state: { sprint: 'S2', params: [] },

  // Admin — modération KYC
  get_kyc_moderation_queue: { sprint: 'S2', params: [] },
  mark_kyc_in_review: { sprint: 'S2', params: ['p_kyc_id'] },
  approve_kyc_submission: { sprint: 'S2', params: ['p_kyc_id', 'p_peer_reviewer_id'] },
  schedule_via_c_session: {
    sprint: 'S2',
    params: ['p_user_id', 'p_scheduled_at', 'p_meeting_url', 'p_moderator_id', 'p_peer_id'],
  },
  list_active_moderators: { sprint: 'S2', params: [] },
  complete_via_c_session: {
    sprint: 'S2',
    params: [
      'p_session_id',
      'p_outcome',
      'p_outcome_notes',
      'p_carta_aligned',
      'p_community_presented',
    ],
  },
  list_my_via_c_sessions: {
    sprint: 'S8',
    params: ['p_from', 'p_to'],
    description: 'Agenda de videollamadas Vía C de la moderadora actual (principal u observadora).',
  },
  reschedule_via_c_session: {
    sprint: 'S8',
    params: ['p_session_id', 'p_scheduled_at', 'p_meeting_url', 'p_moderator_id', 'p_peer_id'],
    description: 'Modifica fecha/enlace/moderadoras de una videollamada planificada (anti-conflicto).',
  },
  cancel_via_c_session: {
    sprint: 'S8',
    params: ['p_session_id', 'p_reason'],
    description: 'La moderación cancela una videollamada planificada (→ email a la usuaria).',
  },
  cancel_my_via_c_session: {
    sprint: 'S8',
    params: ['p_session_id'],
    description: 'La usuaria cancela su propia videollamada desde el link del email.',
  },
  fail_via_c_session: {
    sprint: 'S8',
    params: ['p_session_id', 'p_internal_reason', 'p_user_message'],
    description: 'Vía C no superada → rechaza el KYC con motivo interno obligatorio (super admin) + email.',
  },
  reject_kyc_submission: {
    sprint: 'S2',
    params: ['p_kyc_id', 'p_rejection_reason', 'p_rejection_notes'],
  },

  // Sprint S3 — Admin dashboard + reportes + super admin
  get_reports_queue: { sprint: 'S3', params: ['p_priority', 'p_limit'] },
  take_report: { sprint: 'S3', params: ['p_report_id'] },
  resolve_report: {
    sprint: 'S3',
    params: ['p_report_id', 'p_target_user_id', 'p_action', 'p_justification', 'p_peer_reviewer_id', 'p_internal_notes'],
  },
  get_moderation_stats: { sprint: 'S3', params: [] },
  sa_list_all_users: { sprint: 'S3', params: ['p_identity_status', 'p_limit', 'p_offset'] },
  sa_list_all_propios: { sprint: 'S3', params: ['p_status', 'p_limit', 'p_offset'] },
  sa_revoke_kyc: { sprint: 'S3', params: ['p_user_id', 'p_reason', 'p_notes'] },
  sa_reactivate_user: {
    sprint: 'S8',
    params: ['p_user_id'],
    description: 'Reactiva (verifica) a una usuaria rechazada — override super admin + email de activación.',
  },
  list_all_moderators: { sprint: 'S3', params: [] },
  provision_moderator: { sprint: 'S3', params: ['p_user_id', 'p_role'] },
  revoke_moderator: { sprint: 'S3', params: ['p_user_id', 'p_reason'] },
  is_super_admin: { sprint: 'S3', params: [] },

  // Sesión 6 — marketplace vivienda
  get_marketplace_feed: {
    sprint: 'S5',
    params: ['p_user_id', 'p_limit', 'p_only_sello', 'p_exclude_gran_propio'],
    description: 'Ofertas compatibles con el perfil (zonas, presupuesto, hijos).',
  },
  publish_oferta: { sprint: 'S5', params: ['p_oferta_id'] },
  submit_candidatura: { sprint: 'S5', params: ['p_candidatura_id'] },
  accept_visita: { sprint: 'S5', params: ['p_candidatura_id', 'p_visit_at'] },
  reject_candidatura: { sprint: 'S5', params: ['p_candidatura_id', 'p_reason'] },
  propose_oferta_in_conversation: {
    sprint: 'S5',
    params: ['p_conversation_id', 'p_oferta_id'],
    description: 'Carte offre dans le fil · binomio.',
  },
  respond_oferta_proposal: {
    sprint: 'S5',
    params: ['p_proposal_id', 'p_accept'],
  },
  get_candidatura_detail: { sprint: 'S5', params: ['p_candidatura_id'] },
  get_active_candidatura_for_conversation: {
    sprint: 'S5',
    params: ['p_conversation_id'],
    description: 'UUID candidatura active liée au fil (binomio).',
  },
  list_conversation_oferta_proposals: {
    sprint: 'S5',
    params: ['p_conversation_id'],
    description: 'Propuestas vivienda du fil avec statut (pending, declined, etc.).',
  },
  update_candidatura_motivation: {
    sprint: 'S5',
    params: ['p_candidatura_id', 'p_motivation'],
  },
  sign_candidatura_member: {
    sprint: 'S5',
    params: ['p_candidatura_id', 'p_personal_letter'],
  },
  validate_candidatura_dossier_mvp: { sprint: 'S5', params: ['p_candidatura_id'] },
  register_propio_particular: { sprint: 'S5', params: ['p_display_alias', 'p_segment', 'p_legal_name', 'p_contact_email', 'p_city', 'p_province'] },
  get_my_propio_dashboard: { sprint: 'S5', params: [] },
  sign_propio_charter: { sprint: 'S5', params: ['p_charter_version'] },
  submit_propio_kyc: { sprint: 'S5', params: ['p_doc_type', 'p_doc_storage_path', 'p_selfie_storage_path'] },
  approve_propio_kyc: { sprint: 'S5', params: ['p_submission_id'] },
  get_propio_kyc_moderation_queue: { sprint: 'S5', params: [] },
  mark_propio_kyc_in_review: { sprint: 'S5', params: ['p_submission_id'] },
  reject_propio_kyc: { sprint: 'S5', params: ['p_submission_id', 'p_rejection_reason', 'p_rejection_notes'] },
  create_vivienda_oferta_borrador: {
    sprint: 'S5',
    params: ['p_neighborhood_id', 'p_camino', 'p_rent_eur', 'p_description_short', 'p_total_rooms', 'p_fianza_eur'],
  },
  list_propio_candidaturas: { sprint: 'S5', params: ['p_limit'] },
  get_propio_candidatura_detail: { sprint: 'S5', params: ['p_candidatura_id'] },
  generate_dossier_consolidado: { sprint: 'S5', params: ['p_candidatura_id', 'p_force_regenerate'] },
  get_dossier_consolidado_content: { sprint: 'S5', params: ['p_candidatura_id'] },

  // Sprint S4 — Panel asociaciones B2B
  issue_invitation_code: {
    sprint: 'S4',
    params: ['p_organization_id', 'p_cohort_label', 'p_max_uses', 'p_validity_days'],
    description: 'Org admin genera un código de invitación con cohorte + quota + caducidad.',
  },
  get_association_metrics_live: {
    sprint: 'S4',
    params: ['p_organization_id', 'p_cohort_label', 'p_since'],
    description: 'Métricas agregadas anonimizadas en vivo (k≥5). Solo admin org o moderación.',
  },
  generate_association_report: {
    sprint: 'S4',
    params: ['p_organization_id', 'p_period_start', 'p_period_end', 'p_cohort_label'],
    description: 'Materializa snapshot trimestral firmable. Solo moderación.',
  },
  get_my_organizations: {
    sprint: 'S4',
    params: [],
    description: 'Lista las organizaciones donde la usuaria es admin activa.',
  },
  list_my_org_codes: {
    sprint: 'S4',
    params: ['p_organization_id'],
    description: 'Códigos de invitación de la org (activos + histórico).',
  },
  revoke_org_code: {
    sprint: 'S4',
    params: ['p_code_id'],
    description: 'Revoca un código de invitación (org admin o moderación).',
  },
  // Admin asociaciones (moderación)
  admin_list_organizations: {
    sprint: 'S4',
    params: ['p_type', 'p_active', 'p_limit', 'p_offset'],
    description: 'Vista global de organizaciones para moderación.',
  },
  admin_activate_organization: {
    sprint: 'S4',
    params: ['p_org_id', 'p_anti_terf_verified', 'p_notes'],
    description: 'Activa una asociación tras verificación anti-TERF humana.',
  },
  admin_deactivate_organization: {
    sprint: 'S4',
    params: ['p_org_id', 'p_reason'],
    description: 'Desactiva una asociación con motivo obligatorio.',
  },
  admin_add_org_admin: {
    sprint: 'S4',
    params: ['p_org_id', 'p_user_id', 'p_role', 'p_display_name'],
    description: 'Añade admin B2B a una organización (respeta tope 5).',
  },
  admin_add_org_admin_by_email: {
    sprint: 'S8',
    params: ['p_org_id', 'p_email', 'p_role', 'p_display_name'],
    description: 'Añade admin B2B a una organización a partir de su email (la persona debe existir).',
  },
  admin_remove_org_admin: {
    sprint: 'S4',
    params: ['p_org_id', 'p_user_id'],
    description: 'Retira acceso B2B de un admin (soft-delete).',
  },

  // Migration 050 — propio mature (ofertas, sello, agencia)
  get_mis_ofertas: { sprint: 'S5', params: ['p_limit'], description: 'Lista ofertas del propio con estado.' },
  unpublish_oferta: { sprint: 'S5', params: ['p_oferta_id'] },
  duplicate_oferta: { sprint: 'S5', params: ['p_oferta_id'] },
  get_sello_status: { sprint: 'S5', params: [], description: 'Estado sello Vivienda Sororal + auditorías.' },
  get_neighborhood_rent_index: {
    sprint: 'S5',
    params: ['p_neighborhood_id'],
    description: 'Índice referencia alquiler por barrio (alerta Ley 12/2023).',
  },
  register_propio_agencia: {
    sprint: 'S5',
    params: ['p_segment', 'p_display_alias', 'p_legal_name', 'p_entity_nif', 'p_contact_email', 'p_city', 'p_province'],
  },
  submit_propio_agencia_kyc: {
    sprint: 'S5',
    params: ['p_rep_doc_type', 'p_rep_doc_path', 'p_rep_selfie_path', 'p_mandate_path', 'p_nota_simple_path'],
  },
  get_propio_charter_history: { sprint: 'S5', params: [], description: 'Historial versiones Carta Propietarios firmadas.' },

  // Migration 051 — mediación, dossiers, emails, candidaturas usuaria
  create_mediation_ticket: {
    sprint: 'S6',
    params: ['p_other_party_id', 'p_oferta_id', 'p_candidatura_id', 'p_type', 'p_description'],
  },
  get_my_mediation_tickets: { sprint: 'S6', params: ['p_limit', 'p_offset'] },
  get_my_email_preferences: { sprint: 'S6', params: [] },
  set_email_preference: { sprint: 'S6', params: ['p_key', 'p_enabled'] },
  get_my_reports_submitted: { sprint: 'S6', params: ['p_limit', 'p_offset'] },
  get_my_candidaturas_all: { sprint: 'S6', params: ['p_limit', 'p_offset'] },
  admin_get_mediation_queue: { sprint: 'S6', params: ['p_status', 'p_limit', 'p_offset'] },
  admin_take_mediation_ticket: { sprint: 'S6', params: ['p_ticket_id'] },
  admin_resolve_mediation_ticket: { sprint: 'S6', params: ['p_ticket_id', 'p_resolution_notes'] },
  admin_get_dossier_validations_queue: { sprint: 'S6', params: ['p_limit'] },
  admin_approve_dossier_validation: { sprint: 'S6', params: ['p_validation_id', 'p_notes'] },
  admin_block_dossier_validation: { sprint: 'S6', params: ['p_validation_id', 'p_reason'] },
  admin_get_sello_audit_log: { sprint: 'S6', params: ['p_propio_id', 'p_limit'] },
  admin_withdraw_sello: { sprint: 'S6', params: ['p_propio_id', 'p_reason'] },
  admin_restore_sello: { sprint: 'S6', params: ['p_propio_id', 'p_reason'] },

  // Migration 065 — gestión de usuarias por el equipo (moderación + super admin)
  admin_list_users: {
    sprint: 'S8',
    params: ['p_identity_status', 'p_limit', 'p_offset'],
    description: 'Lista de usuarias para el equipo (excluye staff). Moderación o super admin.',
  },
  admin_get_user_profile: {
    sprint: 'S8',
    params: ['p_user_id'],
    description: 'Ficha completa de una usuaria para el formulario de edición admin.',
  },
  admin_update_user_profile: {
    sprint: 'S8',
    params: ['p_user_id', 'p_patch'],
    description: 'Actualiza los campos NO-DNI de una usuaria (whitelist servidor).',
  },
}

export const RPC_BY_SPRINT = Object.entries(RPC_CATALOG).reduce((acc, entry) => {
  const sprint = entry[1].sprint
  ;(acc[sprint] ??= []).push(entry)
  return acc
}, {})
